<template>
  <div class="w-full min-h-[100vh] flex justify-start items-center flex-col py-20 px-10 lg:p-20 lg:gap-40">
    <img class="w-60" src="@/assets/img/logo2.svg"/>
    <div class="flex justify-between flex-col justify-center items-center lg:flex-row w-full max-w-[70vw]">
      <div>
        <img class="max-w-xs lg:max-w-lg mt-3" src="@/assets/img/maintenance.svg"/>
      </div>
      <div>
        <p class="text-2xl text-center lg:text-left lg:text-5xl mt-5 custom-leading font-medium">
          We're undergoing
          a bit<br>
          of scheduled maintenance
        </p>
        <p class="text-base max-w-lg mt-4 text-center lg:text-left">Sorry for the inconvenience but we’re performing some
          maintenance at the moment.</p>
        <div class="flex flex-col max-w-sm justify-center mx-auto">
        <p class="mt-10 text-center">The maintenance ends in</p>

        <div class="flex gap-4 mt-5 justify-center">
          <p class="bg-primary bg-opacity-10 flex flex-col items-center justify-center p-3 lg:p-5 border-primary border min-w-[100px]">
            <span class="text-5xl font-bold">{{hours}}</span><span>Hours</span></p>
          <p class="bg-primary bg-opacity-10 flex flex-col items-center justify-center p-3 lg:p-5 border-primary border min-w-[100px]">
            <span class="text-5xl font-bold">{{minutes}}</span><span>Minutes</span></p>
          <p class="bg-primary bg-opacity-10 flex flex-col items-center justify-center p-3 lg:p-5 border-primary border min-w-[100px]">
            <span class="text-5xl font-bold">{{seconds}}</span><span>Seconds</span></p>
        </div>
        <div class="mt-5 w-full bg-primary border border-black bg-opacity-10 h-7">
          <div
              class="bg-primary h-7 w-3" :style="`width:${percentage}%`"></div>
          <p>{{percentage}}%</p>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-leading{
  line-height:1.3em;
}
</style>
<script setup lang="ts">
import {ref, onMounted, onUnmounted} from 'vue';
import {useAuthStore} from "@/stores/auth";

const authStore = useAuthStore();

// Initialize time values (example: 4 hours, 3 minutes, 10 seconds)
const hours = ref<number>(0);
const minutes = ref<number>(0);
const seconds = ref<number>(0);
const percentage = ref<number>(0);

let interval: number | undefined = undefined;

// Countdown function
const countdown = () => {
  const from = authStore.maintenanceInfo.m.from.getTime();
  const until = authStore.maintenanceInfo.m.until.getTime();
  const current = Date.now();

  const left = Math.floor((until - current )/1000);
  const elapsed = Math.floor((current - from)/1000);
  const total = Math.floor((until - from)/1000);

  if (left <= 0) {
    hours.value = 0;
    minutes.value = 0;
    seconds.value = 0;
    percentage.value = 100;
    if (interval !== undefined) {
      clearInterval(interval);
      interval = undefined;
    }
    window.location.href = '/login';
    return;
  }

  hours.value = Math.floor(left / 3600);
  minutes.value = Math.floor((left - hours.value * 3600) / 60) ;
  seconds.value = Math.floor((left - hours.value * 3600 - minutes.value * 60));
  percentage.value = Math.floor(elapsed*100/total);
};

onMounted(() => {
  interval = window.setInterval(countdown, 1000);
});

onUnmounted(() => {
  if(interval !== undefined){
    clearInterval(interval);
    interval = undefined;
  }
})

</script>